module.exports = __webpack_public_path__ + "img/12.69327c89.png";